export interface ComparisonRow {
  label: string;
  without: string;
  with: string;
}
export const comparisonRows: ComparisonRow[] = [{
  label: 'Zeit für Diagnose',
  without: '2–4 Stunden',
  with: '5 Minuten'
}];
export const includedItems: string[] = ['80-Seiten visueller Atlas mit hochauflösenden botanischen Fotografien', 'Die 7 häufigsten Nährstoff-Mängel (N, P, K, Ca, Mg, Fe) – mit 4-Stufen-Progressionsfotos', 'Der pH-Blockade Fehler-Finder (rettet 60 % der Anfänger)', 'Toxizität vs. Mangelerscheinung: Die Unterscheidungs-Matrix', 'Wasserstress-Diagnose (Überbewässerung vs. Unterbewässerung – keine Verwechselung mehr)', 'Schädlings-Enzyklopädie (Rote Spinne, Weiße Fliege, Thrips) – mit Extremmakros', 'Wurzelkrankheits-Früherkennung (Pythium, Fusarium, Rhizoctonia)', 'Emergency Protocols – Wie man tote Pflanzen in 48 Stunden rettet', '5 Bonus-Tomos (Wert €93, kostenlos)'];
export interface Volume {
  number: string;
  title: string;
  description: string;
  pages: string;
}
export const volumes: Volume[] = [{
  number: 'Band 1',
  title: 'Balkon-Masterplan',
  description: 'Fläche, Gewicht, Sonnenstunden und Wege – dein Balkon durchgeplant, bevor du etwas kaufst.',
  pages: "65 Seiten"
}, {
  number: 'Band 2',
  title: 'Hydroponik-Meisterschaft',
  description: 'EC, pH und Nährlösung im Griff: vom ersten Aufbau bis zur stabilen Dauerernte.',
  pages: "65 Seiten"
}, {
  number: 'Band 3',
  title: 'Licht-&-Energie-Meisterschaft',
  description: 'PPFD, Lichtstunden und Stromkosten – maximaler Ertrag pro Kilowattstunde.',
  pages: "65 Seiten"
}, {
  number: 'Band 4',
  title: 'Bokashi-&-Residuos-Meisterschaft',
  description: 'Küchenreste fermentieren und in lebendiges Substrat und Nährstoffe verwandeln.',
  pages: "65 Seiten"
}, {
  number: 'Band 5',
  title: 'Die-12-Gewinner-Sorten',
  description: 'Die zwölf Sorten mit dem besten Verhältnis von Platz, Zeit und Ertrag – inklusive Steckbriefen.',
  pages: "65 Seiten"
}, {
  number: 'Band 6',
  title: 'Smart-Balcony-Automatisierung',
  description: 'Sensoren, Timer und Pumpensteuerung: dein System läuft weiter, auch im Urlaub.',
  pages: "65 Seiten"
}];
export interface Bonus {
  number: string;
  title: string;
  value: string;
  description: string;
  cover: string;
}
export const bonuses: Bonus[] = [{
  number: 'Bonus 01',
  title: 'Der komplette IKEA & Bauhaus Einkaufsführer',
  value: '€21',
  description: 'Exakte Einkaufslisten, Preise 2026 und Artikelnummern – du gehst in den Baumarkt und weißt genau, was in den Wagen kommt. Keine Fehlkäufe, keine verschwendete Zeit.',
  cover: 'https://cdn.magicpatterns.com/uploads/gA2P2rsC4qeqWAN2NGsqqU/BONO-1-der-komplette-ikea-bauhaus-einkaufsfuhrer.png'
}, {
  number: 'Bonus 02',
  title: 'Saat-Kalender 2026',
  value: '€17',
  description: 'Das komplette Jahres-Planungs-System für Urban Farming in Deutschland, Österreich und der Schweiz: wann du was aussäst, abhängig von Klimazone und Lichtstunden.',
  cover: 'https://cdn.magicpatterns.com/uploads/8B2hhnHYXVpikDkkEvD5Bv/BONO-2-siembra-kalender-2026-das-komplette-jahres-planungs-system-fur-urban-farming-in-deutschland-osterreich-schweiz.png'
}, {
  number: 'Bonus 03',
  title: 'Dünger selber machen',
  value: '€19',
  description: 'Die komplette Anleitung für organische Hydroponik-Nährstoffe: fermentierte Fische, Holzkohle-Extrakte und Bokashi-Geheimnisse – mit exakten Mischverhältnissen.',
  cover: 'https://cdn.magicpatterns.com/uploads/eLEjp7mvC99ffUKpLdn46M/BONO-3-dunger-selber-machen-die-komplette-anleitung-fur-organische-hydroponic-nahrstoffe.png'
}, {
  number: 'Bonus 04',
  title: 'Konservierung & Fermentation Meisterschaft',
  value: '€15',
  description: 'Was du mit der Ernte machst, wenn alles gleichzeitig reif ist: Kimchi, Sauerkraut und eingelegtes Gemüse – haltbar über Monate, ohne Geschmacksverlust.',
  cover: 'https://cdn.magicpatterns.com/uploads/7g8vhqxsC3jhq9Bh2M9WSZ/BONO-4-konservierung-fermentation-meisterschaft.png'
}, {
  number: 'Bonus 05',
  title: 'Der Urbane Erste-Hilfe-Guide (Pflanzen-Doktor)',
  value: '€21',
  description: 'Die Rettung bei Notfällen: Identifiziere sofort Mangelerscheinungen, Schädlinge oder Systemfehler und rette deine Ernte mit präzisen, praxiserprobten Lösungen.',
  cover: 'https://cdn.magicpatterns.com/uploads/44bUWJjxHPCwK93CMe938A/BONO-5-der-urbane-erste-hilfe-guide-fur-pflanzen.png'
}];
export interface Testimonial {
  quote: string;
  name: string;
  location: string;
  role: string;
  avatar: string;
}
export const testimonials: Testimonial[] = [{
  quote: 'Ich habe 3 Ernten verloren, bevor ich das hatte. Sofort verstanden, dass es pH-Blockade war, nicht Stickstoff. Die Pflanze erholte sich in 2 Tagen. Hätte ich das vorher gewusst, hätte ich €500 gespart.',
  name: 'Julia M.',
  location: 'Wien, Österreich',
  role: 'Balkon-Hydroponik, 8 m²',
  avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/4505fd63-7842-4ee1-8c8e-7dfa50f09fe4.jpg'
}, {
  quote: 'Mein System lief, aber ich verstand nicht, warum die Pflanzen nicht optimal wuchsen. Es zeigte mir, dass ich Magnesium-Mangel hatte. Jetzt wachsen sie 30 % schneller. Das ist kein Buch, das ist eine Superpower.',
  name: 'Thomas K.',
  location: 'Zürich, Schweiz',
  role: 'Indoor-NFT-System, 2. Saison',
  avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/f704f562-27ff-4346-acff-736bdf948f48.jpg'
}, {
  quote: 'Das erste Mal, dass ich einen Kopfsalat mit einem Loch im Blatt sah, dachte ich, es war ein Insekt. Es zeigte mir, dass es Kalziummangel war (Tipburn). Seitdem: null Probleme.',
  name: 'Sandra H.',
  location: 'München, Deutschland',
  role: 'Dachterrassen-Garten & Kräuter',
  avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/134d0218-a28d-4b94-93bf-7223588307a1.jpg'
}];
export interface Faq {
  question: string;
  answer: string;
}
export const faqs: Faq[] = [{
  question: 'Ich bin Anfänger. Ist das zu technisch für mich?',
  answer: 'Nein. Es ist speziell für Anfänger gemacht. Jedes Symptom wird mit Fotos gezeigt, nicht mit wissenschaftlichem Jargon. Du schaust, vergleichst mit dem Foto, und du weißt, was zu tun ist. Es dauert 30 Sekunden.'
}, {
  question: 'Ich habe Hydroponik vs. Boden – ist das relevant?',
  answer: 'Das System konzentriert sich auf Hydroponik in Innenräumen und auf Balkonen (dein Setup). 95 % der Symptome sind gleich, egal ob Hydroponik oder Boden. Aber dieses Handbuch ist optimiert für dein Setup.'
}, {
  question: 'Wie schnell sehe ich Ergebnisse?',
  answer: 'Du siehst die Ergebnisse sofort. Beim ersten Problem wirst du die richtige Diagnose in unter 1 Minute haben. Die Pflanze erholt sich – abhängig vom Problem – in 2–7 Tagen.'
}, {
  question: 'Ist das ein PDF oder ein interaktives Format?',
  answer: 'Es ist ein professionelles PDF (auch als Mobile App zugänglich). Du kannst es ausdrucken und neben dein System legen, oder es auf deinem Handy durchsuchen.'
}];

// Hinweis: Das Hero-Bild liegt separat in data/heroImage.ts, damit es leicht austauschbar ist.
export const images = {
  leafMacro: 'https://cdn.magicpatterns.com/patterns/generated-images/ea1935bf-0443-4c1c-bd17-fd2b42f0da08.jpg',
  atlasSpread: 'https://cdn.magicpatterns.com/patterns/generated-images/0ad70ae6-7e10-4381-b9b9-728e2681d912.jpg',
  pestMacro: 'https://cdn.magicpatterns.com/patterns/generated-images/9655b313-38d0-4863-bf7b-3ee2f35eabad.jpg'
};